<span
  [attr.id]="'form-input-info--' + inputElem.name"
  class="form-text text-muted d-block pt-1"
  [translate]="inputElem.helpLabelKey"
></span>
